export default __webpack_public_path__ + "static/media/drawingWalls.9f9d4288.gif";